import { render } from "./DashboardSkeleton.vue?vue&type=template&id=0b8d6d21"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js"

import "./DashboardSkeleton.vue?vue&type=style&index=0&id=0b8d6d21&lang=scss"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QAjaxBar from 'quasar/src/components/ajax-bar/QAjaxBar.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QAjaxBar,QPageContainer});
